import dayjs from 'dayjs'

export const getTraineeStatus = (traineeDetail) => {
  // console.log('traineeDetail', traineeDetail)
  // 申込み済
  if (traineeDetail) {
    const traineeStart = new Date(traineeDetail.course.term[0])
    const traineeEnd = new Date(traineeDetail.course.term[1])

    if (!traineeDetail.enabled) {
      console.log('パターン0')
      return {
        name: 'キャンセル',
        message: ''
      }
    
    // 未払
    } else if (traineeDetail.payment_status === -1) {

      // 決済方法未選択
      if (traineeDetail.payments_en && (traineeDetail.payments_en.length === 0 || traineeDetail.payments_en[0].payment_by === null)) {
        console.log('パターン未払1')
        return {
          name: '未決済',
          message: '受講申込を受け付けました。お支払い方法を選択してください。'
        }
      
      // 決済方法選択済み
      } else {
        console.log('パターン未払2')
        return {
          name: '未決済',
          message: '指定した方法で、お支払い手続きをお願いいたします。'
        }
      }
  
    // 支払済、開催期間前
    // 4．講座受付開始/受付済、5．講座受付終了/受付済（受講開始前）
    } else if (traineeStart > new Date()) {

      if (traineeDetail.course.type === 'online') {
        console.log('パターン4a')
        return {
          name: '開始前',
          message: `受講申込が完了しました。${dayjs(traineeDetail.course.term[0]).format('YYYY年MM月DD日(dd)')}よりオンデマンドで受講ができます。`
        }
      } else {
        console.log('パターン4b')
        return {
          name: '開始前',
          message: `受講申込が完了しました。${dayjs(traineeDetail.course.term[0]).format('YYYY年MM月DD日(dd)')}に会場にて受講してください。`
        }
      }

    // 支払済、開催期間中
    } else if (traineeStart <= new Date() && traineeEnd >= new Date()) {

      // オンデマンド
      if (traineeDetail.course.type === 'online') {

        // 9．受講期間開始/受講終了、10．受講期間終了/受講完了
        if (traineeDetail.attendance) {
          console.log('パターン9, 10、開催期間中')
          return {
            name: '受講完了',
            message: `${traineeDetail.course.year}年度継続的研修の受講が完了しました。修了証をダウンロードして保管してください。`
          }

        // 7．受講期間開始/未受講（受講期間内でオンデマンドかつ未出席）
        } else if (!traineeDetail.start_at) {
          console.log('パターン7')
          return {
            name: '未受講',
            message: `${traineeDetail.course.year}年度継続的研修の講座を開始しました。受講は${dayjs(traineeDetail.course.term[1]).format('YYYY年MM月DD日(dd)')}までに行ってください。`
          }

        // 8．受講期間開始/受講開始（受講期間内でオンデマンドかつ未出席だがstart_atあり）オンデマンドで動画ウィンドウを開いた状態
        } else {
          console.log('パターン8')
          return {
            name: '受講中',
            message: `${traineeDetail.course.year}年度継続的研修の講座を開始しました。${dayjs(traineeDetail.course.term[1]).format('YYYY年MM月DD日(dd)')}までに受講完了登録を行ってください。`
          }
        }
      
      // 会場
      } else {
        console.log('パターン4b、開催期間中')
        return {
          name: '受講中',
          message: `受講申込が完了しました。${dayjs(traineeDetail.course.term[0]).format('YYYY年MM月DD日(dd)')}に会場にて受講してください。`
        }
      }

    // 支払済、開催期間後
    // 11．受講期間終了/未受講、12．受講期間終了/受講開始
    } else {
      if (!traineeDetail.attendance) {
        console.log('パターン11, 12')
        return {
          name: '未完了',
          message: `${traineeDetail.course.year}年度継続的研修の受講期間は終了しました。`
        }

      // 9．受講期間開始/受講終了、10．受講期間終了/受講完了
      } else {
        return {
          name: '受講完了',
          message: `${traineeDetail.course.year}年度継続的研修の受講が完了しました。修了証をダウンロードして保管してください。`
        }
      }
    }

  // 申込みなし
  } else {
    console.log('パターンなし2')
    return {
      name: '申込みなし',
      message: '申込はありません。'
    }
  }
}

// 修了証ダウンロード期間内かどうか
export const isWithinCertificateIssueTerm = (traineeDetail) => {
  const issueterm = traineeDetail?.course?.issueterm
  if (!issueterm || issueterm.length < 2) return true

  const now = dayjs()
  const startDate = dayjs(issueterm[0])
  const endDate = dayjs(issueterm[1])

  return !now.isBefore(startDate) && !now.isAfter(endDate)
}

const ACCESS_TOKEN_BUFFER_MS = 30 * 1000

export const SESSION_EXPIRED_FLAG_KEY = 'sessionExpiredLogout'
export const SESSION_EXPIRED_MESSAGE = 'ログインの有効期限が切れました。再度ログインしてください。'

export const markSessionExpiredLogout = () => {
  sessionStorage.setItem(SESSION_EXPIRED_FLAG_KEY, '1')
}

export const consumeSessionExpiredLogout = () => {
  if (sessionStorage.getItem(SESSION_EXPIRED_FLAG_KEY) === '1') {
    sessionStorage.removeItem(SESSION_EXPIRED_FLAG_KEY)
    return true
  }
  return false
}

export const decodeJwtPayload = (token) => {
  if (!token) return null
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url) return null
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
  } catch (e) {
    console.error('decodeJwtPayload error', e)
    return null
  }
}

export const isAccessTokenValid = (accessToken, bufferMs = ACCESS_TOKEN_BUFFER_MS) => {
  const payload = decodeJwtPayload(accessToken)
  if (!payload?.exp) return false
  return Date.now() < (payload.exp * 1000 - bufferMs)
}

export const isRefreshTokenValid = (accessToken) => {
  const payload = decodeJwtPayload(accessToken)
  if (!payload?.exp_refresh) return false
  return Date.now() < payload.exp_refresh * 1000
}

// JWTトークンの有効期限内ならtrue、期限切れならfalseを返す
export const checkTokenExpire = (accessToken) => {
  return isAccessTokenValid(accessToken, 0)
}
